import { createContext, useContext, useState } from "react";

const ConfigContext = createContext(null);

const initialState = {
  dispensers: 0,
  guns: 0,
  station_id: "",
  station_name: "",
  customer_id: "",
  cpo_name: "",
  status: "UNKNOWN",
  dispensersData: [],
};

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(() => {
    try {
      const saved = localStorage.getItem("app_config");
      return saved ? JSON.parse(saved) : initialState;
    } catch {
      return initialState;
    }
  });

  const updateConfig = (newValues) => {
    setConfig((prev) => {
      const updated = { ...prev, ...newValues };
      localStorage.setItem("app_config", JSON.stringify(updated));
      return updated;
    });
  };

  const resetConfig = () => {
    setConfig(initialState);

    localStorage.removeItem("app_config");
  };

  return (
    <ConfigContext.Provider value={{ config, updateConfig,resetConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("useConfig must be used within ConfigProvider");
  }
  return context;
};
